import { render } from "./AppSidebar.vue?vue&type=template&id=1c3e4fd2"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AppSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c3e4fd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c3e4fd2', __exports__)) {
    api.reload('1c3e4fd2', __exports__)
  }
  
  module.hot.accept("./AppSidebar.vue?vue&type=template&id=1c3e4fd2", () => {
    api.rerender('1c3e4fd2', render)
  })

}


export default __exports__